import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createBrowserHistory } from "history";
import createSagaMiddleware from "redux-saga";
import { createStore, applyMiddleware } from "redux";
import { routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./common/reducers";
import rootSaga from "./common/saga";
import { Provider } from "react-redux";

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = composeWithDevTools({ realTime: true, port: 8000 });

const store = createStore(
  rootReducer(history),
  composeEnhancers(applyMiddleware(sagaMiddleware, routerMiddleware(history)))
);

sagaMiddleware.run(rootSaga);

// if (process.env.REACT_APP_BASE_API_URL === 'https://staging.etiqa.com.sg/MyEtiqa/') {
//   console.log = () => {}
//   console.error = () => {}
//   console.debug = () => {}
//   console.warning = () => {}
// }

// if (process.env.REACT_APP_BASE_API_URL === 'https://www.etiqa.com.sg/TiqConnect/') {
//   console.log = () => {}
//   console.error = () => {}
//   console.debug = () => {}
// }

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
